import { useMemo } from 'react';
import { FieldArray, useFormikContext } from 'formik';
import Spacer from '@antimatterhq/ui/components/spacer';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { FlagSet } from '@antimatterhq/ui/utils/flags';
import { Section } from '@/components/container/section/Section';
import { GoldDataSourceSchemaValues } from '@/zod/schemas/dataSource/Gold';
import { useConfigDataSource } from '@/contexts/ConfigDataSourceContext';
import { ModifyTable } from '@/components/dataSources/modifyTable/ModifyTable';
import { TocWrapper } from '@/components/tableOfContents/ToCWrapper';
import { GoldDataPreviewContainer } from '@/components/dataSources/dataPreviewContainer/gold/GoldDataPreviewContainer';

export const GoldModifyTables = () => {
  const formik = useFormikContext<GoldDataSourceSchemaValues>();
  const { enableDatasourcePreview } = useFlags<FlagSet>();

  const { values } = formik;

  const { dataSource, preset } = useConfigDataSource();

  const sourceTableNames = useMemo(() => {
    const addTableNames =
      dataSource.spec.silver?.transform?.presetOverrides?.addTables?.map(
        (addTable) => addTable.name || '',
      ) || [];
    const modifyTableNames =
      dataSource.spec.silver?.transform?.presetOverrides?.modifyTables?.map(
        (modifyTable) => modifyTable.name || '',
      ) || [];
    return [...addTableNames, ...modifyTableNames];
  }, [dataSource]);

  return (
    <div>
      <FieldArray name="modifyTables">
        {() => {
          return (
            <>
              {!!values.modifyTables.length && <Spacer size="lg" />}

              {values.modifyTables.map((modifyTable, index) => {
                const prefix = `modifyTables.${index}.`;
                return (
                  <div key={prefix}>
                    <TocWrapper
                      name={`modifyTables.${index}`}
                      displayName={modifyTable.name}
                    >
                      {!!index && <Spacer size="lg" />}
                      <Section className="relative">
                        <div className="absolute right-5 top-5">
                          {enableDatasourcePreview && (
                            <GoldDataPreviewContainer
                              tableIndex={index}
                              isModifyTable
                            />
                          )}
                        </div>
                        <ModifyTable
                          index={index}
                          currentTable="gold"
                          previousTable="silver"
                          table={modifyTable}
                          sourceTableNames={sourceTableNames}
                          presetTables={preset?.gold}
                        />
                      </Section>
                    </TocWrapper>
                  </div>
                );
              })}
            </>
          );
        }}
      </FieldArray>
    </div>
  );
};
